// Google user-content photo size hints (GBP review photos, 2026-07-19).
//
// Google review photos arrive as `reviewMediaItems[].thumbnailUrl`, e.g.
//   https://lh3.googleusercontent.com/grass-cs/ACvplmOx…=k-no
//
// lh*.googleusercontent.com URLs carry a trailing `=<options>` token that
// controls the rendered size, and `=sN` requests an N-pixel version. The
// existing Drive helper (upgradeDriveThumbnailSize) only rewrites a token that
// ALREADY has digits (`=s220`, `=s220-h220-p-k-nu`), so a review photo's `=k-no`
// passes through it untouched — hence this sibling, which replaces a
// non-numeric option token outright.
//
// ⚠️ UNVERIFIED FOR THIS URL FAMILY. The `=sN` convention is well-established on
// lh*.googleusercontent.com (and proven in-repo for Drive thumbnails), but we
// have not fetched a live `grass-cs/` review photo to confirm it honours the
// rewrite. The caller MUST therefore treat the upgraded URL as a best-effort
// candidate and fall back to the original thumbnail on load error — which is
// exactly what the lightbox does. If the rewrite turns out to be rejected, the
// visible result is the thumbnail, never a broken image.

const TARGET_SIZE = 1600;

// The trailing `=<options>` token, e.g. `=k-no`, `=s220`, `=w400-h300-p`.
const OPTION_TOKEN = /=[\w-]+$/;

const GOOGLE_USER_CONTENT = /^https:\/\/lh\d+\.googleusercontent\.com\//i;

/**
 * Best-effort full-size variant of a Google user-content photo URL. Returns the
 * input unchanged for any non-Google URL (so it is safe to call on Facebook /
 * Instagram CDN urls in shared components) and for anything carrying a query or
 * fragment, where a trailing `=…` isn't a size token.
 */
export function upgradeGooglePhotoSize(
  url: string | null | undefined,
  size: number = TARGET_SIZE,
): string | null {
  if (!url) return null;
  if (!GOOGLE_USER_CONTENT.test(url)) return url;
  // A query/fragment means the trailing `=value` belongs to a parameter.
  if (url.includes('?') || url.includes('#')) return url;
  if (OPTION_TOKEN.test(url)) return url.replace(OPTION_TOKEN, `=s${size}`);
  return `${url}=s${size}`;
}
